import Vue from 'vue'
import i18n from '@/i18n'
import PdfMake from 'pdfmake/build/pdfmake'
import PdfFonts from 'pdfmake/build/vfs_fonts'

Vue.mixin({
  methods: {
    exportRegistration (registration, headerImage) {
      PdfMake.vfs = PdfFonts.pdfMake.vfs

      let header = []
      if (!this.browserIE11()) {
        header.push({
          image: this.getBase64Image(headerImage),
          width: 40,
          height: 65,
          alignment: 'left'
        })
      }
      header.push({ text: '\n\n' + 'Република Србија' + '\n' + 'МИНИСТАРСТВО ФИНАНСИЈА' + '\n' + 'Управа за трезор', fontSize: 10 })
      header.push({ text: '\n\n' + 'Образац ЦРФ-1' + '\n' + 'Централни регистар фактура', fontSize: 10, alignment: 'right' })

      var docDefinition = {
        content: [
          {
            columns: header
          },
          { text: '\n\n' + i18n.t('userRegistration.registrationFormTitle') + '\n\n\n', style: 'header' },
          { text: i18n.t('register.legalEntityInfo') + '\n\n', style: 'subheader' },
          { text: i18n.t('register.budgetIdNumber') + ' : ', fontSize: 12 },
          { text: registration.budgetNumber, style: 'value' },
          { text: i18n.t('register.budgetIdNumberFootnote') + '\n\n', style: 'small' },
          { text: i18n.t('register.companyName') + ' : ', fontSize: 12 },
          { text: registration.name + '\n\n', style: 'value' },
          {
            columns:
            [
              [
                { text: i18n.t('register.companyNumber') + ' : ', fontSize: 12 },
                { text: registration.companyNumber + '\n\n', style: 'value' }
              ],
              [
                { text: i18n.t('register.taxIdNumber') + ' : ', fontSize: 12 },
                { text: registration.taxIdNumber + '\n\n', style: 'value' }
              ]
            ]
          },
          { text: i18n.t('register.address') + ' : ', fontSize: 12 },
          { text: registration.address + '\n\n', style: 'value' },
          {
            columns:
            [
              [
                { text: i18n.t('register.email') + ' : ', fontSize: 12 },
                { text: registration.email + '\n\n', style: 'value' }
              ],
              [
                { text: i18n.t('general.phone') + ' : ', fontSize: 12 },
                { text: registration.phoneNumber + '\n\n\n', style: 'value' }
              ]
            ]
          },
          { text: i18n.t('register.adminInfo') + '\n\n', style: 'subheader' },
          { text: i18n.t('register.name') + ' : ', fontSize: 12 },
          { text: registration.adminName + '\n\n', style: 'value' },
          { text: i18n.t('register.identityNumber') + ' : ', fontSize: 12 },
          { text: registration.adminIdentityNumber + '\n\n', style: 'value' },
          {
            columns:
            [
              [
                { text: i18n.t('register.email') + ' : ', fontSize: 12 },
                { text: registration.adminEmail + '\n\n', style: 'value' }
              ],
              [
                { text: i18n.t('general.phone') + ' : ', fontSize: 12 },
                { text: registration.adminPhoneNumber + '\n\n\n', style: 'value' }
              ]
            ]
          },
          { text: i18n.t('register.treasuryBranchInfo') + '\n\n', style: 'subheader' },
          { text: i18n.t('register.treasuryBranch') + ' : ', fontSize: 12 },
          { text: registration.treasuryBranch + '\n', style: 'value' },
          {
            columns:
            [
              { text: '_____________________________', fontSize: 12, alignment: 'right', margin: [ 0, 35, 15, 5 ] }
            ]
          },
          {
            columns:
            [
              { text: 'М.П. Потпис одговорног лица' + '\n\n\n', fontSize: 11, alignment: 'right', margin: [ 0, 0, 15, 0 ] }
            ]
          },
          {
            columns:
            [
              { text: '*Kада је потписник овлашћења привредни субјекат не постоји обавеза овере печатом', alignment: 'left', style: 'small' }
            ]
          }
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            alignment: 'center'
          },
          value: {
            fontSize: 12,
            bold: true
          },
          subheader: {
            fontSize: 14,
            bold: true
          },
          quote: {
            italics: true
          },
          small: {
            fontSize: 9
          }
        }
      }
      PdfMake.createPdf(docDefinition).download('nalog.pdf')
    },
    getBase64Image (img) {
      if (this.browserIE11()) { return }

      // Create an empty canvas element
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height

      // Copy the image contents to the canvas
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)

      return canvas.toDataURL('image/png')
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins/export.js